<template>
  <v-timeline align-top dense>
    <v-timeline-item :color="setColor(item)" small v-for="(item, index) in timelineList" :key="index"
      ><span class="font-weight-bold">
        {{ item.label }}
      </span>
      <v-list-item-subtitle
        >{{ formatDateAsMMDDYYYY(item.date) }}
        <span v-if="item.dateEnd">- {{ formatDateAsMMDDYYYY(item.dateEnd) }}</span></v-list-item-subtitle
      >
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import moment from "moment";
import { formatDateAsMMDDYYYY } from "@/lib/formatters";

export default {
  name: "Timeline",
  computed: {
    timelineList() {
      const list = [
        {
          label: "Build",
          date: this.pack.dateBuildStart,
          dateEnd: this.pack.dateBuildEnd,
        },
        {
          label: "Workflow",
          date: this.pack.dateWorkflowStart,
          dateEnd: this.pack.dateWorkflowEnd,
        },
        { label: "QA", date: this.pack.dateQaStart, dateEnd: this.pack.dateQaEnd },
        {
          label: "UAT",
          date: this.pack.uatStart,
          dateEnd: this.pack.uatEnd,
        },
        {
          label: "End-User Documentation",
          date: this.pack.dateEndUserDocumentation,
        },
        {
          label: "Member Operationalize",
          date: this.pack.dateOperationalizeStart,
          dateEnd: this.pack.dateOperationalizeEnd,
        },
        {
          label: "EP Demo",
          date: this.pack.dateEpDemo,
        },
        {
          label: "Production Implementation",
          date: this.pack.productionDate,
        },
        {
          label: "Stabilization",
          date: this.pack.dateStabilizationStart,
          dateEnd: this.pack.dateStabilizationEnd,
        },
      ];

      return list.filter(item => item.date !== null);
    },
  },
  data() {
    return {
      currentDate: new Date(),
      formatDateAsMMDDYYYY: formatDateAsMMDDYYYY,
    };
  },
  methods: {
    setColor(item) {
      const today = moment(this.currentDate, "YYYY/MM/DD");
      if (item.dateEnd && today.isBetween(item.date, item.dateEnd, "days", true)) {
        return "green";
      } else if (today.isAfter(item.date, "days", false)) {
        return "grey";
      } else if (today.isSame(item.date, "days")) {
        return "green";
      } else {
        return "primary";
      }
    },
  },
  props: {
    pack: {
      type: Object,
      required: true,
    },
  },
};
</script>
